import IconContainer from "./IconContainer"
import { IconProps } from "./IconUtilities"

const IconLock: React.FC<IconProps> = ({ className, size, contained }) => {
	if (contained) {
		return (
			<IconContainer
				className={className}
				size={size}
			>
				<path d="M11.7858 5H11.0715V3.57143C11.0715 1.6 9.47148 0 7.50005 0C5.52862 0 3.92862 1.6 3.92862 3.57143V5H3.21434C2.42862 5 1.78577 5.64286 1.78577 6.42857V13.5714C1.78577 14.3571 2.42862 15 3.21434 15H11.7858C12.5715 15 13.2143 14.3571 13.2143 13.5714V6.42857C13.2143 5.64286 12.5715 5 11.7858 5ZM7.50005 11.4286C6.71434 11.4286 6.07148 10.7857 6.07148 10C6.07148 9.21429 6.71434 8.57143 7.50005 8.57143C8.28577 8.57143 8.92862 9.21429 8.92862 10C8.92862 10.7857 8.28577 11.4286 7.50005 11.4286ZM9.71434 5H5.28577V3.57143C5.28577 2.35 6.27862 1.35714 7.50005 1.35714C8.72148 1.35714 9.71434 2.35 9.71434 3.57143V5Z" />
			</IconContainer>
		)
	}
	return (
		<path d="M11.7858 5H11.0715V3.57143C11.0715 1.6 9.47148 0 7.50005 0C5.52862 0 3.92862 1.6 3.92862 3.57143V5H3.21434C2.42862 5 1.78577 5.64286 1.78577 6.42857V13.5714C1.78577 14.3571 2.42862 15 3.21434 15H11.7858C12.5715 15 13.2143 14.3571 13.2143 13.5714V6.42857C13.2143 5.64286 12.5715 5 11.7858 5ZM7.50005 11.4286C6.71434 11.4286 6.07148 10.7857 6.07148 10C6.07148 9.21429 6.71434 8.57143 7.50005 8.57143C8.28577 8.57143 8.92862 9.21429 8.92862 10C8.92862 10.7857 8.28577 11.4286 7.50005 11.4286ZM9.71434 5H5.28577V3.57143C5.28577 2.35 6.27862 1.35714 7.50005 1.35714C8.72148 1.35714 9.71434 2.35 9.71434 3.57143V5Z" />
	)
}

export default IconLock
